import { render, staticRenderFns } from "./Papua_list.vue?vue&type=template&id=0bb8e3e6&scoped=true&"
import script from "./Papua_list.vue?vue&type=script&lang=js&"
export * from "./Papua_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb8e3e6",
  null
  
)

export default component.exports